import {Pipe, PipeTransform} from "@angular/core";

@Pipe({ name: 'joinArrayPipe' })
export class JoinArrayPipe implements PipeTransform {
  transform(arr: string[], joinChar: string = ', ') {
    return arr.join(joinChar);
  }
}
